/**
 * Bio component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Image from "gatsby-image"

import { rhythm } from "../utils/typography"

const Bio = () => {
  const data = useStaticQuery(graphql`
    query BioQuery {
      avatar: file(absolutePath: { regex: "/profile-pic.jpg/" }) {
        childImageSharp {
          fixed(width: 50, height: 50) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      site {
        siteMetadata {
          author
          social {
            twitter
          }
        }
      }
    }
  `)

  const { author, social } = data.site.siteMetadata
  return (
    <div
      style={{
        display: `flex`,
        marginBottom: rhythm(2.5),
        textAlign: 'center',
        backgroundColor: '#d6d6d612',
        borderRadius: '1rem',
        padding: '1rem'
      }}
    >
      <p
        style={{
          marginBottom: '0rem'
        }}
      >
    Inspect Element is a collection of Chrome Developer Tool tips learnt over time. From simple usability tips to complex JavaScript debugging. 
      </p>
    </div>
  )
}

export default Bio
